import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseAccountService } from "admin/baseLogin/BaseAccountService";
import { LoginResponse } from "admin/baseLogin/LoginResponse";
import { RouterUtils } from "admin/_global/GlobalUtils";

export class BaseForgotPass
{
    isLoading: boolean = false;
    isRequested: boolean = false;
    error: string;
    email: string;

    constructor(
        protected router: Router,
        protected route: ActivatedRoute,
        protected accountService: BaseAccountService)
    {
    }

    async requestResetToken(email: string): Promise<void> {
        this.isLoading = true;
        this.error = null;

        let result: LoginResponse;

        try {
            result = await this.accountService.forgotPasswordRequest(email).toPromise();
        }
        catch (err) {
            console.error(err);
            this.error = err.Description;
            this.isLoading = false;
            return;
        }

        this.isLoading = false;

        if (!result.Success) {
            this.error = result.Error;
            return;
        }

        this.isRequested = true;
        this.email = email;
    }

    async requestPasswordReset(pass: string, token: string): Promise<void> {
        this.isLoading = true;
        this.error = null;

        let result: LoginResponse;

        try {
            result = await this.accountService.forgotPassword(this.email, pass, token).toPromise();
        }
        catch (err) {
            console.error(err);
            this.error = err.Description;
            this.isLoading = false;
            return;
        }

        if (!result.Success) {
            this.error = result.Error;
            this.isLoading = false;
            return;
        }

        this.goToLogin();
    }

    goToRegister(): void {
        const code: string = RouterUtils.GetParamByName(this.route, "code");
        if (code) {
            this.router.navigate(['/register/company-join/' + code]);
        }
        else {
            this.router.navigate(['/register']);
        }
    }

    goToLogin(): void {
        const code: string = RouterUtils.GetParamByName(this.route, "code");
        if (code) {
            this.router.navigate(['/login/company-join/' + code]);
        }
        else {
            this.router.navigate(['/login']);
        }
    }
}